// 域名字典
export const DOMAIN_VALUE = {
    aicp: 'aicp',
    wuhan: 'pku-wuhan', // 北武院访问域名前缀
    smartPlatform: 'smart-platform' // 智能平台系统访问域名前缀
};
export const DOMAIN_KEY = Object.values(DOMAIN_VALUE);
// 不同域名处理
export const DOMAIN_HANDLE = {
    [DOMAIN_VALUE.aicp]: {
        title: '暗物智AI科创平台',
        logoUrl: require('@/assets/image/logo.svg'),
        loginLogoUrl: require('@/assets/image/logo.svg'),
        key: DOMAIN_VALUE.aicp,
        className: 'aicp',
        userAgreement: '暗物智AI科创平台用户协议'
    },
    [DOMAIN_VALUE.wuhan]: {
        title: 'AI科创平台',
        logoUrl: require('@/assets/image/wuhan/logo.svg'),
        loginLogoUrl: require('@/assets/image/wuhan/login-logo.png'),
        key: DOMAIN_VALUE.wuhan,
        className: 'wuhan',
        ico: 'data:;base64,=',
        userAgreement: '用户协议'
    },
    [DOMAIN_VALUE.smartPlatform]: {
        title: '智能平台系统',
        logoUrl: require('@/assets/image/smartPlatform/login-logo.png'),
        loginLogoUrl: require('@/assets/image/smartPlatform/login-logo.png'),
        key: DOMAIN_VALUE.smartPlatform,
        className: 'wuhan',
        ico: 'data:;base64,=',
        userAgreement: '用户协议'
    }
};
export const isLocal = () => !location.host.endsWith('.dm-ai.com');
export const getDomainHandle = (name: 'title' | 'logoUrl' | 'loginLogoUrl' | 'className' | 'key' | 'userAgreement') => {
    const host = location.host;
    if (isLocal()) {
        return DOMAIN_HANDLE[DOMAIN_VALUE.aicp][name];
    }

    const activeHandle = DOMAIN_KEY.find(x => host.startsWith(x + '-'));
    if (activeHandle) {
        return DOMAIN_HANDLE[activeHandle][name];
    }
};

export const setDomainIco = () => {
    if (isLocal()) {
        return;
    }
    const activeHandle = DOMAIN_KEY.find(x => location.host.startsWith(x + '-'));
    const ico = activeHandle && DOMAIN_HANDLE[activeHandle]?.ico;
    if (ico) {
        let $favicon = document.querySelector('link[rel="icon"]') as any;
        $favicon.href = ico;
    }
};
